import styled from 'styled-components';
import { Box, FormHelperText, Typography } from '@mui/material';
import COLORS from '@app/colors';

export const TitlesWrapper = styled(Box)({
  display: 'grid',
  gap: '10px',
  gridTemplateColumns: '1fr 1fr 1fr',
});

export const VisibleWrapper = styled(Box)({
  padding: '15px 10px',
  margin: '10px 0px',
  border: `1px solid ${COLORS.border}`,

  display: 'flex',
  gap: '30px',
  alignItems: 'center',
  justifyContent: 'flex-start',

  '> div': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  }
});

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const StyledFormHelperText = styled(FormHelperText)({
  color: 'red !important'
});

export const ImageName = styled(Typography)({
  fontSize: 11,
});
